import Vue from 'vue'

export default {
  getTokens (context) {
    return Vue.api.get('engine/tokens').then((res) => res.data)
  },
  createToken (context, data) {
    return Vue.api.post('engine/tokens', data).then((res) => res.data)
  },
  engine (context, data) {
    return Vue.api.delete('engine/tokens/' + data.id)
  }
}
